import { render, staticRenderFns } from "./VxCellLink.vue?vue&type=template&id=18110c5b&"
import script from "./VxCellLink.vue?vue&type=script&lang=js&"
export * from "./VxCellLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports